import { proxy, useSnapshot } from 'valtio';

import { type ConnectionStatus } from '@canvas/model/network';
import { type BoardSyncStatus } from '@canvas/model/network';

export const defaultConnectionStatus: ConnectionStatus = 'online';
const defaultBoardSyncStatus: BoardSyncStatus = 'saved';

export interface CurrentConnectionStatus {
  connectionStatus: ConnectionStatus;
  boardSyncStatus: BoardSyncStatus;
}

export const currentConnectionStatus = proxy<CurrentConnectionStatus>({
  connectionStatus: defaultConnectionStatus,
  boardSyncStatus: defaultBoardSyncStatus,
});

/**
 * Hook that returns a boolean indicating whether the user is online.
 *
 * Automatically updates when user's connection status changes
 */
export const useIsUserOnline = () => {
  const userConnectionStatus = useSnapshot(currentConnectionStatus);

  return userConnectionStatus.connectionStatus === 'online';
};

/**
 * Function that returns a boolean indicating whether the user is online.
 */
export const isUserOnline = () => {
  return currentConnectionStatus.connectionStatus === 'online';
};
